import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { trackChatEndedEvent, trackEventSpentCredit, trackSessionSummaryEvent } from '@app/actions/chat';
import { Popover } from '@barges/react';
import ChatEnded from '../created_chat/chat_ended';
import Constants from '../../config/const';
import VoipChat from '../voip_chat';
import Starting from '../chat_overlay/starting';
import SelectChatCredit from '../chat_overlay/select_chat_credit';
import VoipPurchaseFlow from './VoipPurchaseFlow';
import classes from '../created_chat/classes.module.scss';
import AdvisorEnded from '../voip_chat/advisor_ended';

const renderTopImg = (profilePictureUrl) => (
  <img
    className={ classes.advisorImage }
    src={ profilePictureUrl }
    alt=""
  />
);

const renderSelectCredit = (voipType, isNewUser, profilePictureUrl) => (
  <div className={ classes.addCreditContainer }>
    <Popover isOpen renderTopOverlay={ isNewUser ? () => renderTopImg(profilePictureUrl) : null } className="created-voip-chat-add-credit-container">
      <SelectChatCredit chatType={ voipType } isContinue selectorOpenedTime={ new Date() } />
    </Popover>
    <AdvisorEnded chatType={ voipType } />
  </div>
);

const renderPurchaseDetails = (voipType, voipPurchaseOnBack, purchaseSuccess) => (
  <div className={ classes.addCreditContainer }>
    <VoipPurchaseFlow
      voipType={ voipType }
      isContinue
      voipPurchaseOnBack={ voipPurchaseOnBack }
      purchaseSuccess={ purchaseSuccess }
    />
  </div>
);

const voipActionList = (voipType, voipPurchaseOnBack, purchaseSuccess, isNewUser, profilePictureUrl) => ({
  [Constants.voipChatStates.connectProvider]: {
    voipChat: <VoipChat />, content: <Starting chatType={ voipType } />
  },
  [Constants.voipChatStates.connecting]: {
    voipChat: <VoipChat />, content: <Starting chatType={ voipType } />
  },
  [Constants.voipChatStates.starting]: {
    voipChat: <VoipChat />, content: <Starting chatType={ voipType } />
  },
  [Constants.voipChatStates.endedConversation]: {
    voipChat: null, content: <ChatEnded chatType={ voipType } />
  },
  [Constants.voipChatStates.inConversation]: {
    voipChat: <VoipChat />, content: null
  },
  [Constants.voipChatStates.finishing]: {
    voipChat: <VoipChat />, content: null
  },
  [Constants.voipChatStates.subscribed]: {
    voipChat: <VoipChat />, content: null
  },
  [Constants.voipChatStates.paused]: {
    voipChat: null,
    content: renderSelectCredit(voipType, isNewUser, profilePictureUrl)
  },
  [Constants.voipChatStates.paymentRequiredOnContinue]: {
    voipChat: null,
    content: renderPurchaseDetails(voipType, voipPurchaseOnBack, purchaseSuccess)
  },
  [Constants.voipChatStates.continue]: {
    voipChat: <VoipChat />, content: null
  }
});

export default class CreatedVoipChat extends PureComponent {
  static propTypes = {
    voipState: PropTypes.string.isRequired,
    voipType: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    voipPurchaseOnBack: PropTypes.func.isRequired,
    purchaseSuccess: PropTypes.func,
    totalCharged: PropTypes.string,
    orderId: PropTypes.number,
    userId: PropTypes.number.isRequired,
    advisorId: PropTypes.number.isRequired,
    totalDuration: PropTypes.number,
    profilePictureUrl: PropTypes.string.isRequired,
    isNewUser: PropTypes.bool
  };

  static defaultProps = {
    purchaseSuccess: null,
    totalCharged: null,
    orderId: null,
    totalDuration: null,
    isNewUser: false
  };

  componentDidUpdate(prevProps) {
    const {
      voipState, totalCharged, orderId, userId, advisorId, voipType, totalDuration
    } = this.props;
    if (prevProps.voipState !== Constants.voipChatStates.endedConversation
      && voipState === Constants.voipChatStates.endedConversation) {
      trackEventSpentCredit(parseFloat(totalCharged).toFixed(2), userId, orderId);
      trackChatEndedEvent({
        chatType: voipType, advisorId, userId, orderId, totalCharged, totalDuration
      });
      trackSessionSummaryEvent({ orderId, sessionType: voipType });
    }
  }

  render() {
    const {
      voipState, voipType, voipPurchaseOnBack, purchaseSuccess, isNewUser, profilePictureUrl
    } = this.props;
    const { voipChat, content } = voipActionList(voipType, voipPurchaseOnBack, purchaseSuccess, isNewUser, profilePictureUrl)[voipState];

    return (
      <div className={ classes.callingScreen }>
        { voipChat }
        { content }
        <AdvisorEnded chatType={ voipType } />
      </div>
    );
  }
}
